import {useQuery} from "@apollo/client";
import {GetUserSelf} from "./User.js";

export function useGetUserSelf(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        GetUserSelf,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['GetUserSelf']) ? data : previousData;
    const extracted = (holder) ? holder['GetUserSelf'] : null;

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncGetUserSelf(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: GetUserSelf,
        variables
    });
    const extracted = data ? data['GetUserSelf'] : null;
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
